var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-box"},_vm._l((_vm.btn.top),function(btn){return _c('vxe-button',{key:btn.btncode,staticClass:"btn-item",attrs:{"type":"text","status":"primary","icon":btn.btnicon ? btn.btnicon : 'el-icon-connection'},nativeOn:{"click":function($event){return _vm.btnClick(btn.btncode)}}},[_vm._v(_vm._s(btn.btnname))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }